import { Component, ObjectManager } from '../../../concepts/objects';
import { AudioManager } from '../../../platform/AudioManager';
import { EditorSession } from '../../canvas/EditorSession';
import { WidgetManager } from '../../canvas/workspace/widgets/WidgetManager';
import { ActiveObject, resolve } from '../../Container';
import { Jukebox, JukeboxProgressAttr } from './Jukebox';

export class JukeboxMechanics extends ActiveObject {

    @resolve(AudioManager) private readonly audio!: AudioManager;
    @resolve(ObjectManager) private readonly objects!: ObjectManager;
    @resolve(EditorSession) private session: EditorSession;
    @resolve(WidgetManager) private widgets: WidgetManager;

    public start(): void {
        this.burden(
            this.objects.on('Jukebox', 'released', this.silenceDeletedBox),
            this.objects.createTrigger('Jukebox.forceSync')
                .for(Jukebox).onChangesTo('playingFrom', 'playingSince', 'pausedAt').doForEach(this.syncJukebox),
            this.startInterval(),
            () => this.silenceAllMusic(),
        );
    }

    private silenceAllMusic = () => {
        this.objects.getAll(Jukebox).forEach(x => this.audio.stop(`${x.id}/music`));
    };

    private silenceDeletedBox = ([jb]: [Component]) => {
        this.audio.stop(`${jb.id}/music`);
    };

    private startInterval = () => {
        const intervalId = setInterval(this.tickMusicTimer, 1000);
        return () => clearInterval(intervalId);
    };

    private tickMusicTimer = () => {
        this.objects.getAll(Jukebox).forEach(x => this.syncJukebox(x));
    };

    private syncJukebox = (jb: Jukebox) => {
        const { currentTrack, elapsed } = jb.getCurrentTrack();
        const nextTrack = jb.getNextTrack();
        const currentPath = currentTrack.path;
        const progress = elapsed / currentTrack.length;

        // Used for looping ambient tracks
        const realLength = currentTrack.realLength;

        this.audio.merge({
            id: `${jb.id}/music`,
            playing: jb.playing,
            time: (realLength ? elapsed % realLength : elapsed) / 1000,
            path: currentPath,
        });

        if (nextTrack !== currentTrack) {
            this.audio.preload(`${jb.id}/music`, nextTrack.path);
        }

        JukeboxProgressAttr.set(jb, progress);
    };
}
